import axios from 'axios';
import { handleResponse } from './HelperService';


const getSync = (type, onSuccess, onError) => {
    const response = axios.get(`v1/sap-resync/${type}`);
    return handleResponse(response, onSuccess, onError);
};

export {
    getSync
};